import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser'; 
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { fetchGems,  getImageUrl } from '../api';
import './Home.css';

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import sriLankaBg from '../assets/srilanka-bg.jpg';
import aboutBg from '../assets/about-bg.jpg'; 
import collectionImg1 from '../assets/collection1.jpg';
import collectionImg2 from '../assets/collection2.jpg'; 
import collectionBg from '../assets/collection-bg.jpg';
import jewelryBg from '../assets/jewelry-bg.jpg';
import jewelryMain from '../assets/jewelry-main.jpg';  
import necklaceImg from '../assets/necklace.jpg';
import earringImg from '../assets/earring.jpg';
import braceletImg from '../assets/bracelet.jpg';
import ringImg from '../assets/ring.jpg';
import garnetImg from '../assets/garnet.jpg';
import amethystImg from '../assets/amethyst.jpg';
import aquamarineImg from '../assets/aquamarine.jpg';
import diamondImg from '../assets/diamond.jpg';
import emeraldImg from '../assets/emerald.jpg';
import pearlImg from '../assets/pearl.jpg';
import rubyImg from '../assets/ruby.jpg';
import peridotImg from '../assets/peridot.jpg';
import sapphireImg from '../assets/sapphire.jpg';
import opalImg from '../assets/opal.jpg';
import topazImg from '../assets/topaz.jpg';
import turquoiseImg from '../assets/turquoise.jpg';
import contactBg from '../assets/contact-bg.jpg'; 

const BIRTHSTONES = [
  { month: 'January',   stone: 'Garnet',     image: garnetImg },
  { month: 'February',  stone: 'Amethyst',   image: amethystImg },
  { month: 'March',     stone: 'Aquamarine', image: aquamarineImg },
  { month: 'April',     stone: 'Diamond',    image: diamondImg },
  { month: 'May',       stone: 'Emerald',    image: emeraldImg },
  { month: 'June',      stone: 'Pearl',      image: pearlImg },
  { month: 'July',      stone: 'Ruby',       image: rubyImg },
  { month: 'August',    stone: 'Peridot',    image: peridotImg },
  { month: 'September', stone: 'Sapphire',   image: sapphireImg },
  { month: 'October',   stone: 'Opal',       image: opalImg },
  { month: 'November',  stone: 'Topaz',      image: topazImg },
  { month: 'December',  stone: 'Turquoise',  image: turquoiseImg } ]

const BANNERS = [
  { image: banner1 },
  { image: banner2 },
  { image: banner3 }
];

const FEATURES = [
  { icon: '📋', title: 'Buy Certified Gemstones', desc: '100% genuine gems with certification from top Sri Lanka gem authorities.' },
  { icon: '✈️', title: 'Free Shipping', desc: 'Fast global delivery in 1-4 days on orders over LKR 50k with tracking.' },
  { icon: '🔒', title: 'Secure Payments', desc: 'All payments are safe, encrypted, and insured for your protection.' },
  { icon: '🎧', title: '24/7 Support', desc: 'Get expert help anytime via chat or \ncall.' }
];

const JEWELRY_CATEGORIES = [
  { name: 'Necklaces', image: necklaceImg },
  { name: 'Earrings',  image: earringImg },
  { name: 'Bracelets', image: braceletImg },
  { name: 'Rings',     image: ringImg }
];

const TESTIMONIALS = [
  {
    name: "Jacob Jones", date: "21 Feb 2026", rating: 4,
    text: "I've bought gems from many places, but this is by far the most reliable source. Genuine stones and excellent service.",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
    initials: "JJ", color: "#7F77DD"
  },
  {
    name: "Robert Fox", date: "04 Sep 2025", rating: 4,
    text: "Authentic, certified, and beautifully cut stones. Highly recommended for anyone looking for real gems.",
    img: "https://randomuser.me/api/portraits/men/54.jpg",
    initials: "RF", color: "#1D9E75"
  },
  {
    name: "Wade Warren", date: "17 Jan 2025", rating: 4,
    text: "I was skeptical because of the price but they are amazing! Impeccable and worth the price.",
    img: "https://randomuser.me/api/portraits/men/76.jpg",
    initials: "WW", color: "#D85A30"
  },
  {
    name: "Emily Carter", date: "10 Mar 2026", rating: 5,
    text: "Absolutely stunning sapphire! The quality exceeded my expectations. Will definitely be ordering again.",
    img: "https://randomuser.me/api/portraits/women/44.jpg",
    initials: "EC", color: "#2A7FBA"
  },
  {
    name: "Michael Torres", date: "28 Nov 2025", rating: 5,
    text: "Exceptional quality and fast shipping. The ruby I purchased was exactly as described — brilliant and certified.",
    img: "https://randomuser.me/api/portraits/men/61.jpg",
    initials: "MT", color: "#B5451B"
  },
  {
    name: "Sophia Nguyen", date: "05 Jan 2026", rating: 4,
    text: "Beautiful emerald, perfectly cut. The team was very helpful in guiding me to the right stone for my jewelry.",
    img: "https://randomuser.me/api/portraits/women/68.jpg",
    initials: "SN", color: "#1A8C5B"
  },
];


export default function Home() {
  const navigate = useNavigate();
  const [currentBanner, setCurrentBanner] = useState(0);
  const [rareGems, setRareGems] = useState([]);

const [contactForm, setContactForm] = useState({
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  message: ''
});
  const [sending, setSending] = useState(false);
  const testimonialRef = useRef(null);

   useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);


  useEffect(() => {
    const timer = setInterval(() => setCurrentBanner(b => (b + 1) % BANNERS.length), 5000);
    return () => clearInterval(timer);
  }, []);
useEffect(() => {
  Promise.all([
    fetchGems({ category: 'Rare' }),
    fetchGems({ category: 'Collector' })
  ])
    .then(([rareData, collectorData]) => {
      const combined = [...rareData, ...collectorData].slice(0, 6);
      console.log('🔍 Rare gems data:', combined); 
      console.log('🔍 First gem image field:', combined[0]?.image); 
      console.log('🔍 getImageUrl result:', combined[0]?.image ? getImageUrl(combined[0].image) : 'no image');
      setRareGems(combined);
    })
    .catch(err => console.error('Failed to fetch gems:', err));
}, []);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const cards = entry.target.querySelectorAll('.testimonial-card');
          cards.forEach((card, i) => {
            card.style.animationDelay = `${i * 0.2}s`;
            card.classList.add('animate-in');
          });
        }
      });
    }, { threshold: 0.2 });
    if (testimonialRef.current) observer.observe(testimonialRef.current);
    return () => observer.disconnect();
  }, []);


const handleSendMessage = async (e) => {
  e.preventDefault();
  setSending(true);

  try {
   
    await sendMessage({
      name: `${contactForm.firstName || ''} ${contactForm.lastName || ''}`.trim(),
      email: contactForm.email,
      message: contactForm.message,
    });

   
    await emailjs.send(
      'service_12bmvfh',      
      'template_odvfb7h',      
      {
        from_name:    `${contactForm.firstName || ''} ${contactForm.lastName || ''}`.trim(),
        from_email:   contactForm.email,
        phone:        contactForm.phone || 'Not provided',
        message:      contactForm.message,
        to_email:     'raveeshaamarawickrama200@gmail.com',
      },
      'FNYczlSkULJOUVBaX'       
    );

    alert('Message sent successfully!');
    setContactForm({ firstName: '', lastName: '', email: '', phone: '', message: '' });

  } catch (err) {
    console.error(err);
    alert('Failed to send message. Please try again.');
  }

  setSending(false);
};

function TestimonialCard({ t }) {
  const [imgError, setImgError] = useState(false);  
  return (
    <div className="testimonial-card">
      <div className="testimonial-header">
        {!imgError ? (
          <img
            className="testimonial-avatar"
            src={t.img}
            alt={t.name}
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="testimonial-avatar-fallback" style={{ background: t.color + "22", color: t.color }}>
            {t.initials}
          </div>
        )}
        <div className="testimonial-meta">
          <p className="testimonial-name">{t.name}</p>
          <p className="testimonial-date">{t.date}</p>
          <div className="testimonial-stars">{"★".repeat(t.rating)}{"☆".repeat(5 - t.rating)}</div>
        </div>
      </div>
      <p className="testimonial-text">{t.text}</p>
      <svg className="testimonial-quote" viewBox="0 0 28 22" fill="none">
        <path d="M0 22V13.4C0 9.8 0.9 6.9 2.7 4.7C4.5 2.5 7.2 1 10.8 0.3L12 3.1C10 3.6 8.4 4.5 7.2 5.8C6 7.1 5.3 8.7 5.1 10.6H10.8V22H0ZM17.2 22V13.4C17.2 9.8 18.1 6.9 19.9 4.7C21.7 2.5 24.4 1 28 0.3L29.2 3.1C27.2 3.6 25.6 4.5 24.4 5.8C23.2 7.1 22.5 8.7 22.3 10.6H28V22H17.2Z" fill="#3B6DD0" opacity="0.55"/>
      </svg>
    </div>
  );
}

  return (
    <div className="home">
      <Navbar />

     
      <section className="hero-banner">
       
        {BANNERS.map((b, i) => (
          <div
            key={i}
            className={`banner-slide ${i === currentBanner ? 'active' : ''}`}
            style={{ backgroundImage: `url(${b.image})` }}
          />
        ))}

        <div className="banner-content" key={currentBanner}>
          <div className="banner-dots">
            {BANNERS.map((_, i) => (
              <button
                key={i}
                className={`banner-dot ${i === currentBanner ? 'active' : ''}`}
                onClick={() => setCurrentBanner(i)}
                aria-label={`Go to banner ${i + 1}`}
              />
            ))}
          </div>
        </div>

        <button
          className="banner-arrow banner-arrow-left"
          onClick={() => setCurrentBanner(b => (b - 1 + BANNERS.length) % BANNERS.length)}
        >‹</button>
        <button
          className="banner-arrow banner-arrow-right"
          onClick={() => setCurrentBanner(b => (b + 1) % BANNERS.length)}
        >›</button>
      </section>

   
      <section className="features-section">
        <div className="features-divider">
          <span> Inspired by nature and each piece reflects purity, elegance, and timeless charm </span>
        </div>
        <div className="features-grid">
          {FEATURES.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h4>{f.title}</h4>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

     


<section className="about-section">
  <img src={aboutBg} alt="" className="about-bg-img" aria-hidden="true" />
  <div className="about-content">
    <h2 className="about-title">Natural Gems – The House of Natural Gemstones</h2>
    
   
    <div className="about-image-side" />

   
    <div className="about-text">
      <p>At Silan Gems, we go beyond supplying gemstones — we transform them into meaningful creations. Our bespoke gemstone jewelry service allows you to bring your vision to life with precision and elegance, guided by decades of expertise.</p>
      <p>Each creation is thoughtfully designed and crafted to celebrate life's most special moments, ensuring that your gemstone is not just beautiful, but deeply personal. From mine to masterpiece, we are dedicated to delivering timeless luxury that inspires confidence and lasting value.</p>
    </div>
  </div>
</section>


<section className="srilanka-section" style={{ backgroundImage: `url(${sriLankaBg})` }}>
  
</section>

    
<section 
  className="collection-section" 
  style={{ backgroundImage: `url(${collectionBg})` }}
>
  <h2>Explore our Natural Gem Collection</h2>
  <p className="collection-desc">Discover a carefully curated selection of natural gemstones designed for collectors, jewelers, and gemstone enthusiasts. Choose a category below to explore stones that match your needs.</p>
  <div className="collection-grid">
    <div className="collection-card">
      <div className="collection-img" style={{ backgroundImage: `url(${collectionImg1})` }} />
      <button onClick={() => navigate('/classical')} className="collection-btn">VIEW COLLECTION</button>
    </div>
    <div className="collection-card">
      <div className="collection-img" style={{ backgroundImage: `url(${collectionImg2})` }} />
      <button onClick={() => navigate('/retail')} className="collection-btn">VIEW COLLECTION</button>
    </div>
  </div>
</section>

    

<section className="rare-section">
  <div className="rare-outer-border">
    <div className="rare-mid-border">
      <div className="rare-inner-box">

    
        <div className="rare-label">
          <h3>Rare and Collector</h3>
          <p><em>Unique High Value Stones</em></p>
        </div>

      
        <div className="rare-gems-grid">
          {rareGems.length === 0 ? (
            <p style={{ color: 'red', gridColumn: '1/-1' }}>No gems found — check DB or fetch</p>
          ) : (
            rareGems.map((gem, i) => (
  <div
    key={i}
    className="rare-gem-item"
    onClick={() => gem._id && navigate(`/gem/${gem._id}`)}
  >
    <img
      src={getImageUrl(gem.image)}
      alt={gem.name}
      className="rare-gem-img"
      onError={(e) => {
        console.error(' Image failed to load:', getImageUrl(gem.image));
        e.target.style.border = '2px solid red';
      }}
      onLoad={() => console.log(' Image loaded:', getImageUrl(gem.image))}
    />
    <span className="rare-gem-name">{gem.name}</span>
  </div>
))
          )}
        </div>

      </div>
    </div>
  </div>
</section>

<section
  id="jewelry-section"
  className="jewelry-section"
  style={{ backgroundImage: `url(${jewelryBg})` }}
>

  <div className="jewelry-watermark">JEWELRIES</div>


  <h2 className="jewelry-title">Elegant Jewelry Crafted with Pure Gems</h2>

  <div className="jewelry-content">
   
    <div className="jewelry-imgs">
      <img src={jewelryMain} alt="Jewelry" className="jewelry-main-img" />
    </div>

    <div className="jewelry-text">
      <h4>Jewelry Speaks Volumes Of Stories</h4>
      <p>Each piece is crafted with the finest natural gemstones, reflecting timeless beauty and rarity. Our jewelry captures the brilliance of nature and transforms it into wearable art.</p>
    </div>
  </div>

  

  <div className="jewelry-categories">
    {JEWELRY_CATEGORIES.map((cat, i) => (
      <div key={i} className="jewelry-cat-card">
        <div
          className="jewelry-cat-img"
          style={{ backgroundImage: `url(${cat.image})` }}
        />
        <p>{cat.name.toUpperCase()}</p>
      </div>
    ))}
  </div>
</section>

    
<section id="birthstones-section" className="birthstones-section">

  <div className="birthstones-stack-3">
    <div className="birthstones-stack-2">
      <div className="birthstones-card">

        <div className="birthstones-header-box">
          <h2>Birthstones</h2>
          <p>The perfect gift, personalized by birth</p>
        </div>

        <div className="birthstones-grid">
          {BIRTHSTONES.map((bs, i) => (
            <div key={i} className="birthstone-item">
              <img
                src={bs.image}
                alt={bs.stone}
                className="birthstone-img"
              />
              <span className="birthstone-month">{bs.month}</span>
              <span className="birthstone-stone">{bs.stone}</span>
            </div>
          ))}
        </div>

      </div>
    </div>
  </div>
</section>

<section className="testimonials-section" ref={testimonialRef}>
  <div className="marquee-wrapper">
    <div className="marquee-track">
      {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) => (
        <TestimonialCard key={i} t={t} />
      ))}
    </div>
  </div>
</section>

    
<section
  id="contact-section"
  className="contact-section"
  style={{ backgroundImage: `url(${contactBg})` }}
>
  <div className="contact-inner">

    <div className="contact-info">
      <h2>Let's talk with us</h2>
      <p className="contact-sub">
        Questions, comments, or suggestions? Simply fill in the form and we'll be in touch shortly.
      </p>
      <div className="contact-details">
        <div className="contact-detail-item">
  <svg viewBox="0 0 24 24" fill="none" stroke="#4169e1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
  <span>London, United Kingdom</span>
</div>
<div className="contact-detail-item">
  <svg viewBox="0 0 24 24" fill="none" stroke="#4169e1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.81a16 16 0 0 0 6.28 6.28l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
  <span> +44(0)20 3371 178</span>
</div>
<div className="contact-detail-item">
  <svg viewBox="0 0 24 24" fill="none" stroke="#4169e1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
  </svg>
  <span>naturalgems@gmail.com</span>
</div>
      </div>
    </div>

   
    <form className="contact-form" onSubmit={handleSendMessage}>
      <div className="contact-form-row">
        <input
          type="text"
          placeholder="First Name"
          value={contactForm.firstName || ''}
          onChange={e => setContactForm({ ...contactForm, firstName: e.target.value })}
          required
        />
        <input
          type="text"
          placeholder="Last Name*"
          value={contactForm.lastName || ''}
          onChange={e => setContactForm({ ...contactForm, lastName: e.target.value })}
        />
      </div>
      <input
        type="email"
        placeholder="Email*"
        value={contactForm.email}
        onChange={e => setContactForm({ ...contactForm, email: e.target.value })}
      />
      <input
        type="tel"
        placeholder="Phone Number*"
        value={contactForm.phone || ''}
        onChange={e => setContactForm({ ...contactForm, phone: e.target.value })}
      />
      <textarea
        placeholder="Your message..."
        rows={5}
        value={contactForm.message}
        onChange={e => setContactForm({ ...contactForm, message: e.target.value })}
        required
      />
      <button type="submit" disabled={sending} className="send-btn">
        {sending ? 'SENDING...' : 'SEND MESSAGE'}
      </button>
    </form>
  </div>
</section>  
      <Footer />
    </div>
  );
}